<template>
	<div class="cmpnt-box">
	    <header class="lmy-header lmy-header-w">
	        <!-- <i class="iconfont icon-back" ></i> -->
	        房间及人数
	    </header>
	    <div class="lmy-select-amount1">
	        <div class="room-amount">
	            	房间数
	            <div class="count-box">
	            	<span class="sub" v-show="data.RoomCount>1" @click="data.RoomCount--">-</span>
	                <span class="count">{{data.RoomCount}}</span>
	                <span class="add" @click="data.maxCount?(data.RoomCount<data.maxCount?data.RoomCount++:data.RoomCount):( data.RoomCount<5?data.RoomCount++:data.RoomCount)">+</span>
	            </div>
	        </div>
	        <div class="people-amount" v-if="data.from<1">
	            <div class="room-name">房间</div>
	            <div class="people-count">
	                成人
	                <div class="count-box">
	                    <span class="sub" v-show="data.AdultCount>1" @click="data.AdultCount--">-</span>
	                    <span class="count">{{data.AdultCount}}</span>
	                    <span class="add" @click="data.AdultCount++">+</span>
	                </div>
	            </div>
	            <div class="people-count">
	                儿童
	                <div class="count-box">
	                    <span class="sub" v-show="data.ChildrenCount>0" @click="data.ChildrenCount--;ChildrenAgesList.shift('')">-</span>
	                    <span class="count">{{data.ChildrenCount}}</span>
	                    <span class="add" v-if="data.ChildrenCount<2"  @click="data.ChildrenCount++;ChildrenAgesList.push({'active':false,'ChildrenAges':5})">+</span>
	                    <span class="add"  v-if="data.ChildrenCount==2"  >+</span>
	                </div>
	            </div>
		
	            <div class="child-info" @click="openAgeSelect(child)" v-show="data.ChildrenCount>0" v-for="(child,index) in ChildrenAgesList">
	                儿童年龄{{index+1}}
	                <span class="age" >{{child.ChildrenAges?child.ChildrenAges:'年龄'}}</span>
	                <i class="iconfont icon-more"></i>
	               	<ul class="age-select" v-show="child.active">
			            <li @click="selectAge(child,1,$event)"> 1岁</li>
			            <li @click="selectAge(child,2,$event)"> 2岁</li>
			            <li @click="selectAge(child,3,$event)"> 3岁</li>
			            <li @click="selectAge(child,4,$event)"> 4岁</li>
			            <li @click="selectAge(child,5,$event)"> 5岁</li>
			            <li @click="selectAge(child,6,$event)"> 6岁</li>
			            <li @click="selectAge(child,7,$event)"> 7岁</li>
			            <li @click="selectAge(child,8,$event)"> 8岁</li>
			            <li @click="selectAge(child,9,$event)"> 9岁</li>
			            <li @click="selectAge(child,10,$event)"> 10岁</li>
			    
			        </ul>
	            </div>
	        </div>

	        <div class="lmy-select-btn" @click="select">选好了</div>
	    </div>
	</div>
	
</template>
<script>
	export default{
		name:'roomAndPerson',
		props:{
			rpData:{
				type:Object,
				default:()=>{
					return{}
				}
			}
		},
		data(){
			return{
				data:{},
				ChildrenAgesList:[],
				isAgeSelectShow:false
			}
		},
		watch:{
			rpData(val){
				this.data=val;
			},
		},
		methods:{
			selectAge(item,age,$event){
				$event.stopPropagation();
				this.$nextTick(function () {
					item.active=false;
					this.$set(item,'ChildrenAges',age);
				})
			},
			openAgeSelect(item){
				this.$nextTick(function () {
					this.$set(item,'active',item.active?false:true);
	　　　　　　	});
			},
			select(){
				this.$emit('select',this.data,this.ChildrenAgesList);
			},
			initAge(){
				var that=this;
				this.data.ChildrenAges.forEach((item,index)=>{
				
					
					that.ChildrenAgesList.push({'active':false,'ChildrenAges':item})

				})
			}
		},
		mounted(){
			this.data=this.rpData;
			if(this.rpData.ChildrenAges&&this.rpData.ChildrenAges.length>0){

				this.initAge();
			}

		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/cmpnt/roomAndPerson.vue